import config from '../config/config';

const DEVICE_TYPE = 'web';

class AuthService {
  static getHeaders(customHeaders = {}) {
    const headers = { ...customHeaders };
    if (config.API_BASE_URL.includes('ngrok')) {
      headers['ngrok-skip-browser-warning'] = 'true';
    }
    return headers;
  }

  static async sendVerificationCode(phoneNumber, smsConsent = true) {
    const response = await fetch(`${config.API_BASE_URL}/sendSMS`, {
      method: 'POST',
      headers: this.getHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ phoneNumber, smsConsent })
    });

    if (response.status === 428) {
      throw new Error('You must consent to receive SMS verification codes.');
    }

    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || 'Failed to send verification code');
    }

    return response.json();
  }

  static async login(phoneNumber, verificationCode) {
    const response = await fetch(`${config.API_BASE_URL}/phoneVerify`, {
      method: 'POST',
      headers: this.getHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        phoneNumber,
        verifyCode: verificationCode,
        deviceType: DEVICE_TYPE
      })
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || 'Verification failed');
    }

    const data = await response.json();
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('userUuid', data.uuid);
    localStorage.setItem('phoneNumber', phoneNumber);

    return data;
  }

  static async refreshAccessToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    const userUuid = localStorage.getItem('userUuid');

    if (!refreshToken || !userUuid) {
      throw new Error('No refresh token available');
    }

    const response = await fetch(`${config.API_BASE_URL}/accessToken`, {
      method: 'POST',
      headers: this.getHeaders({
        'Content-Type': 'application/json',
        'X-User-Uuid': userUuid
      }),
      body: JSON.stringify({ refreshToken })
    });

    if (!response.ok) {
      this.logout();
      throw new Error('Token refresh failed. Please log in again.');
    }

    const data = await response.json();
    localStorage.setItem('accessToken', data.accessToken);
    if (data.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }

    return data.accessToken;
  }

  static getAuthHeaders() {
    const accessToken = localStorage.getItem('accessToken');
    const phoneNumber = localStorage.getItem('phoneNumber');
    const userUuid = localStorage.getItem('userUuid');

    return this.getHeaders({
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...(phoneNumber ? { 'X-Phone-Number': phoneNumber } : {}),
      ...(userUuid ? { 'X-User-Uuid': userUuid } : {}),
      'X-Device-Token': '',
      'Content-Type': 'application/json'
    });
  }

  static isAuthenticated() {
    return !!localStorage.getItem('accessToken');
  }

  static logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userUuid');
    localStorage.removeItem('phoneNumber');
  }
}

export default AuthService;
